export interface Faq {
  id: number;
  subtitle: string;
  title: string;
  details: string;
}

export const faqs: Faq[] = [
  {
    id: 1,
    subtitle: `Two-Factor Authentication (TFA)`,
    title: `What is Two-Factor Authentication (TFA)?`,
    details: `Two-Factor Authentication (TFA) is an additional layer of security that requires not only a password and username but also something that only the user has on them, such as a mobile device to approve authentication requests.`
  },
  {
    id: 2,
    subtitle: `Two-Factor Authentication (TFA)`,
    title: `Why do I need an authenticator app like Microsoft Authenticator or Google Authenticator?`,
    details: `These apps generate time-based one-time passwords (TOTP) that provide an extra layer of security, ensuring that even if your password is compromised, your account remains secure.`
  },
  {
    id: 3,
    subtitle: `Two-Factor Authentication (TFA)`,
    title: `How do I set up TFA on my account?`,
    details: `TFA is set up by the system administrator role. If your account is not TFA activated, contact your system administrator. Once activated, follow the prompts to scan a QR code with your authenticator app.`
  },
  {
    id: 4,
    subtitle: `Two-Factor Authentication (TFA)`,
    title: `What should I do if I lose access to my authenticator app?`,
    details: `If you lose access to your authenticator app, you should contact your system administrator to help you regain access to your account.`
  },
  {
    id: 5,
    subtitle: `Two-Factor Authentication (TFA)`,
    title: `Can I use a different TFA method instead of an authenticator app?`,
    details: `The system currently recommends using an authenticator app like Microsoft Authenticator or Google Authenticator for the best security practices.`
  },
  {
    id: 6,
    subtitle: `Roles and permissions`,
    title: `How are roles and permissions managed in the system?`,
    details: `Roles and permissions are managed based on the user's assigned role within the system, which dictates the options and reports they can access.`
  },
  {
    id: 7,
    subtitle: `Roles and permissions`,
    title: `What roles are available in the system?`,
    details: `The system has various roles such as Sysadmin, Opsadmin, and Opsmember, each with different levels of access and permissions.`
  },
  {
    id: 8,
    subtitle: `Roles and permissions`,
    title: `Can I see all options and reports if I have an administrator role?`,
    details: `Yes, an administrator has full access to all options and reports within the system.`
  },
  {
    id: 9,
    subtitle: `Roles and permissions`,
    title: `How can I change a user's role?`,
    details: `To change a user's role, an administrator must access the user management section, select the user, and assign a new role.`
  },
  {
    id: 10,
    subtitle: `Roles and permissions`,
    title: `Why can't I access certain reports or options?`,
    details: `Access to certain reports or options is restricted based on your role. Contact your administrator if you believe you need additional permissions.`
  },
  {
    id: 11,
    subtitle: `Services and Campaigns`,
    title: `What are Services in the system?`,
    details: `Services are a way to group multiple campaigns to simplify system administration.`
  },
  {
    id: 12,
    subtitle: `Services and Campaigns`,
    title: `How do I create a new Service?`,
    details: `To create a new Service, navigate to the Services section and select the option to create a new Service. Provide the necessary details and save.`
  },
  {
    id: 13,
    subtitle: `Services and Campaigns`,
    title: `What is a Campaign?`,
    details: `A Campaign is a specific project or initiative managed within a Service that involves your Humanized Virtual Agents (HVAs) working towards a particular goal.`
  },
  {
    id: 14,
    subtitle: `Services and Campaigns`,
    title: `How can I assign a user to a Campaign?`,
    details: `To assign a user to a Campaign, go to the Campaign management section, select the Campaign, and add the user to the list of assigned users.`
  },
  {
    id: 15,
    subtitle: `Services and Campaigns`,
    title: `Can a user be assigned to multiple Campaigns?`,
    details: `Yes, a user can be assigned to multiple Campaigns, depending on their role and the permissions set by the administrator.`
  },
  {
    id: 16,
    subtitle: `Services and Campaigns`,
    title: `How do I view statistics for a Campaign?`,
    details: `To view statistics for a Campaign, go to the Campaign details section and select the statistics tab.`
  },
  {
    id: 17,
    subtitle: `Services and Campaigns`,
    title: `What type of details can I see for a Campaign?`,
    details: `You can see details such as performance metrics, agent activity, and specific outcomes related to the Campaign.`
  },
  {
    id: 18,
    subtitle: `Services and Campaigns`,
    title: `How do I manage a Campaign?`,
    details: `Campaign management can be done through the Campaigns section, where you can edit details, assign users, and monitor progress.`
  },
  {
    id: 19,
    subtitle: `Token-Based Authentication`,
    title: `What is token-based authentication?`,
    details: `Token-based authentication is a security process where the system issues a token to the user upon logging in, which is then used to authenticate subsequent requests without needing to re-enter login credentials.`
  },
  {
    id: 20,
    subtitle: `Token-Based Authentication`,
    title: `How often are tokens renewed?`,
    details: `Tokens are periodically renewed to maintain security. The exact frequency depends on the system settings.`
  },
  {
    id: 21,
    subtitle: `Token-Based Authentication`,
    title: `What happens if my token expires?`,
    details: `If your token expires, you will be prompted to log in again to obtain a new token.`
  },
  {
    id: 22,
    subtitle: `Token-Based Authentication`,
    title: `Can I manually renew my token?`,
    details: `Token renewal is typically handled automatically by the system. However, logging out and logging back in will also renew your token.`
  },
  {
    id: 23,
    subtitle: `Token-Based Authentication`,
    title: `Why does the system use token-based authentication?`,
    details: `Token-based authentication enhances security by reducing the need for repeated transmission of user credentials and allows for secure session management.`
  },
  {
    id: 24,
    subtitle: `Token-Based Authentication`,
    title: `What should I do if I am repeatedly asked to log in?`,
    details: `If you are repeatedly asked to log in, it may indicate an issue with token renewal. Contact your system administrator for assistance.`
  },
  {
    id: 25,
    subtitle: `Token-Based Authentication`,
    title: `How can I log out of the system?`,
    details: `To log out, navigate to your account settings on the top right of the screen and select the option to log out. This will invalidate your current token and require you to log in again to access the system.`
  }
];
